export default __webpack_public_path__ + "static/media/PersonalLaw.ef8b9a0b.svg";